import { accountCreatedRoutine, ACCOUNT_CREATED_CLEANUP } from './routines'
import { logoutRoutine } from '@/store/modules/auth/routines'
import { state as initialState } from './index'

export default {
  [accountCreatedRoutine.TRIGGER](context, payload) {
    context.commit(accountCreatedRoutine.TRIGGER, payload)
  },

  [logoutRoutine.SUCCESS](context) {
    context.commit(ACCOUNT_CREATED_CLEANUP, initialState)
  }
}
